import useMediaQuery from '@mui/material/useMediaQuery';

const useOrientation = () => {
  return useMediaQuery('(orientation: portrait)', { noSsr: true });
};

export default useOrientation;
